import {computed, defineComponent, type PropType, ref, watch} from 'vue';
import {getNameByIsoCode} from "@/app/shared/helpers/country.ts";
import {ActorDto, AthumiService} from "@/api/enterprise-gateway-api.proxy.ts";

export interface BillingDetail {
    id?: string;
    vatNumber? : string;
    identifier? : string;
    companyName: string;
    street?: string;
    streetNumber?: string;
    bus?: string;
    postCode?: string;
    city?: string;
    countryCode?: string;
    emails: { service: AthumiService, email: string }[]
}

export default defineComponent({
    name: 'AegBillingDetails',
    props: {
        billingDetails: {
            type: Object as PropType<BillingDetail>,
            required: true,
        }
    },
    setup(props) {
        const billingDetail =  ref<BillingDetail>(props.billingDetails);

        const hasAddress = computed((): boolean => {
            return Boolean(billingDetail.value?.street && billingDetail.value?.streetNumber && billingDetail.value?.postCode && billingDetail.value?.city && billingDetail.value?.countryCode);
        });

        const billingAddress = computed(() => {
            if (!hasAddress.value) {
                return 'Niet gekend';
            }
            const streetParts = [billingDetail.value.street, billingDetail.value.streetNumber, `${billingDetail.value.bus ? `bus ${billingDetail.value.bus}` : ''}`].join(' ').trim();
            const cityParts = `- ${[billingDetail.value.postCode, billingDetail.value.city].join(' ').trim()}${billingDetail.value.city && billingDetail.value.countryCode ? ` - ${getNameByIsoCode(billingDetail.value.countryCode)}` : ''}`;
            return `${streetParts} ${cityParts}`.trim();
        });

        watch(() => props.billingDetails, (newVal) => {billingDetail.value = newVal}, {immediate: true, deep: true});

        const formatEmail = (email: string | null) => {
            return !email ? 'niet gekend' : email;
        }

        const hasEmail = (email: string | null) => {
            return !!email;
        }

        const only1MailAddress = computed(() => {
            return (billingDetail.value.emails?.length ?? 0) === 1;
        });

        return {
            billingDetail,
            billingAddress,
            hasAddress,
            only1MailAddress,
            hasEmail,
            formatEmail
        }
    }
})
